
















import { Component, Vue } from "vue-property-decorator";
import ExperiencesList from "@/components/experiences/experiences-list/ExperiencesList.vue";
import { UtilitiesFunctions } from "../helpers";
import "@/plugins/metaHeadful";

@Component({
  components: {
    ExperiencesList
  }
})
export default class Experiences extends Vue {
  handleRoute = UtilitiesFunctions.handleRoute;
  mounted() {}
}
